var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96973 5.51513L3.03039 4.45447L8.00006 9.42414L12.9697 4.45447L14.0304 5.51513L8.00006 11.5455L1.96973 5.51513Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownS);
export default __webpack_public_path__ + "static/media/chevron-down-S.7ce046a7e69e1ffc7f805cb07063288c.svg";
export { ForwardRef as ReactComponent };